"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonPin = void 0;
const lodash_1 = require("lodash");
const common_1 = require("../common");
const Pin_1 = require("../common/Pin");
var LessonPin;
(function (LessonPin) {
    LessonPin.testPointTypes = ['OPEN_QUESTION', 'DRAG_QUESTION', 'MULTIPLE_CHOICE'];
    function testPointsForPin(pin) {
        // If the pin can't have an invalid answer, return points
        if (!Pin_1.Pin.isOfType(pin, ...LessonPin.testPointTypes)) {
            return 0;
        }
        // We're left with items that CAN have an invalid answer
        // If it's invalid question, return 0
        if (Pin_1.Pin.isOfType(pin, 'MULTIPLE_CHOICE', 'DRAG_QUESTION') && !containsCorrectAnswer(pin)) {
            return 0;
        }
        // defaults to 1 point
        return (0, lodash_1.isNil)(pin.settings.testPoints) ? 1 : pin.settings.testPoints;
    }
    LessonPin.testPointsForPin = testPointsForPin;
    function correctAnswersForPins(pins) {
        const items = (0, lodash_1.map)(pins, (pin) => {
            const answers = correctAnswersForPin(pin);
            if ((0, lodash_1.isEmpty)(answers)) {
                return undefined;
            }
            return [pin.id, answers];
        });
        return (0, lodash_1.fromPairs)((0, lodash_1.compact)(items));
    }
    LessonPin.correctAnswersForPins = correctAnswersForPins;
    function hasPossibleTestPoints(pin) {
        return Pin_1.Pin.isOfType(pin, ...LessonPin.testPointTypes);
    }
    LessonPin.hasPossibleTestPoints = hasPossibleTestPoints;
    function isDragQuestion(pin) {
        return pin.type === 'DRAG_QUESTION';
    }
    LessonPin.isDragQuestion = isDragQuestion;
    function isSlide(pin) {
        return pin.type === 'SLIDE';
    }
    LessonPin.isSlide = isSlide;
    /** Returns an array of correct answers for the given pin */
    function correctAnswersForPin(pin) {
        switch (pin.type) {
            case 'DRAG_QUESTION':
                const dragQuestionTeacherSettings = pin.teacherSettings;
                const res = {
                    correctDropzone: {},
                };
                // TODO DragQuestion
                // (pin.pinComponents || [])
                //   // TODO @davey remove any
                //   .filter((c: any) => c.settings && c.settings.isDraggable)
                //   .forEach((c: any) => {
                //     const correct = c.settings.correctDropzone;
                //     res.correctDropzone[c._id] = correct && !_.isEmpty(correct) ? correct : [];
                //   });
                return res;
            case 'OPEN_QUESTION':
                const openQuestionTeacherSettings = pin.teacherSettings;
                // TODO OpenQuestion
                // const oqContent = item.custom as OpenQuestion.LessonContent;
                // return _.compact(_.isArray(oqContent.answer) ? oqContent.answer : [oqContent.answer]);
                return [];
            case 'MULTIPLE_CHOICE':
                const quizTeacherSettings = pin.teacherSettings;
                return quizTeacherSettings.correctAnswers;
            default:
                return undefined;
        }
    }
    LessonPin.correctAnswersForPin = correctAnswersForPin;
    /** true if a correct answer has been configured for the given pin */
    function containsCorrectAnswer(pin) {
        return !(0, lodash_1.isEmpty)(correctAnswersForPin(pin));
    }
    LessonPin.containsCorrectAnswer = containsCorrectAnswer;
    // export function itemContainsCorrectAnswer(item: PinItem): boolean {
    //   return !_.isEmpty(correctAnswersForPinItem(item));
    // }
    // TODO @davey
    function firstPin(pins) {
        // return _.find(pins, (p) => p.isFirstPin == true) || pins[0];
        return pins[0];
    }
    LessonPin.firstPin = firstPin;
    function isExcludedForExclusionType(pin, exclusion) {
        return pin.exclusions?.includes(exclusion) ?? false;
    }
    LessonPin.isExcludedForExclusionType = isExcludedForExclusionType;
    function pinIsAssignmentType(pin, type) {
        const exclusion = type === 'realtime' ? 'realtime' : 'homework';
        return !isExcludedForExclusionType(pin, exclusion);
    }
    LessonPin.pinIsAssignmentType = pinIsAssignmentType;
    function lessonPinsForAssignmentType(pins, type) {
        return (0, lodash_1.filter)(pins, (pin) => pinIsAssignmentType(pin, type));
    }
    LessonPin.lessonPinsForAssignmentType = lessonPinsForAssignmentType;
    function firstPinForAssignmentType(pins, type) {
        const pinsForAssignment = lessonPinsForAssignmentType(pins, type);
        return firstPin(pinsForAssignment);
    }
    LessonPin.firstPinForAssignmentType = firstPinForAssignmentType;
    function sort(pins) {
        pins.sort((a, b) => {
            if (a.order == b.order) {
                if (a.createdAt < b.createdAt)
                    return -1;
                if (a.createdAt > b.createdAt)
                    return 1;
                return 0;
            }
            if (a.order < b.order)
                return -1;
            if (a.order > b.order)
                return 1;
            return 0;
        });
        return pins;
    }
    LessonPin.sort = sort;
    function allowTestPoints(pin) {
        if (!pin || !hasPossibleTestPoints(pin))
            return false;
        if (pin.type == 'MULTIPLE_CHOICE' && (0, lodash_1.isEmpty)(pin.teacherSettings.correctAnswers)) {
            return false;
        }
        return true;
    }
    LessonPin.allowTestPoints = allowTestPoints;
    function differentiation(pin) {
        if (!pin)
            return;
        return pin.settings.differentiation;
    }
    LessonPin.differentiation = differentiation;
    // TODO: Remove
    /** fixes the recursive pin bug which was created a long time ago */
    // export function cleanRecursivePin<T extends LessonPin>(pin: T): T {
    //   const copy = _.cloneDeep(pin);
    //   // bug where we recursivly copied the pindata in the settings object
    //   copy.item.components = _.map(
    //     pin.item.components,
    //     (c) =>
    //       _.omit(
    //         c,
    //         'settings.item',
    //         'settings._id',
    //         'settings.lesson',
    //         'settings.user',
    //         'settings.creationDate',
    //         'settings.isPublic',
    //         'settings.shouldIndex'
    //       ) as Component.All
    //   );
    //   return copy;
    // }
    function sortByOrder(a, b) {
        return a.order - b.order;
    }
    LessonPin.sortByOrder = sortByOrder;
    // TODO @davey
    // export function copyWithoutId(sourcePin: LessonPin, lessonId: string, userId: string) {
    //   const newPin = _.cloneDeep(sourcePin);
    //   newPin.user = userId;
    //   newPin.lesson = lessonId;
    //   newPin.item.components = Component.cloneWithRelations(newPin.item);
    //   newPin.creationDate = new Date();
    //   newPin.item.modifiedDate = new Date();
    //   newPin.parentPinId = undefined;
    //   return newPin;
    // }
})(LessonPin || (exports.LessonPin = LessonPin = {}));
//# sourceMappingURL=LessonPin.js.map